export enum SslProtocolEnum {
  Tls = 1,
  Tls11 = 2,
  Tls12 = 3,
  Tls13 = 4,
}
